import { createSlice } from "@reduxjs/toolkit";

export const commonProductSlice = createSlice({
    name: "commonProduct",
    initialState: {
        commonProducts: [],
        commonProductsCopy: [],
        commonProductDetail: {}
    },
    reducers: {
        getCommonProductsReducer: (state, action) => {
            state.commonProducts = action.payload;
            state.commonProductsCopy = action.payload;
        },
        getCommonProductByIdReducer: (state, action) => {
            const productId = action.payload;
            state.commonProductDetail = state.commonProducts.find(commonProduct => commonProduct.id === productId);
        },
        filterByBrandReducer: (state, action) => {
            const productsByBrands = state.commonProducts.filter(
                commonProduct => commonProduct.brand === action.payload
            )
            state.commonProductsCopy = action.payload === 'allBrands' ? [...state.commonProducts] : productsByBrands
        },
        filterByCategoryReducer: (state, action) => {
            const producstByCategory = state.commonProducts.filter(
                commonProduct => commonProduct.category === action.payload
            )
            state.commonProductsCopy = action.payload === 'allCategories' ? [...state.commonProducts] : producstByCategory
        },
        // orderByPriceReducer: (state, action) => {
        //     const commonProductsOrderPrice = [...state.commonProductsCopy];
            
        //     const compareAscending = (a, b) => a.price - b.price;
        
        //     const compareDescending = (a, b) => b.price - a.price;
        
        //     commonProductsOrderPrice.sort(action.payload === 'A' ? compareAscending : compareDescending);
        
        //     state.commonProductsCopy = commonProductsOrderPrice;
        // },
    }
});

export const { getCommonProductsReducer, getCommonProductByIdReducer, filterByBrandReducer, filterByCategoryReducer } = commonProductSlice.actions;

export default commonProductSlice.reducer;